export default __webpack_public_path__ + "static/intergations-presentation-kz-167f32e2eceab6dd31a19dde4b038d1a.png";